/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Pit1_TInputs */

const en_to_xml_pit1_t = /** @type {(inputs: To_Xml_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converting back is ambiguous, so the round trip is lossy`)
};

const ko_to_xml_pit1_t = /** @type {(inputs: To_Xml_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`되돌리는 변환은 모호하므로 왕복은 손실이 있습니다`)
};

const ja_to_xml_pit1_t = /** @type {(inputs: To_Xml_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戻す変換は曖昧なので、往復は損失があります`)
};

/**
* | output |
* | --- |
* | "Converting back is ambiguous, so the round trip is lossy" |
*
* @param {To_Xml_Pit1_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_pit1_t = /** @type {((inputs?: To_Xml_Pit1_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Pit1_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_pit1_t(inputs)
	if (locale === "ko") return ko_to_xml_pit1_t(inputs)
	return ja_to_xml_pit1_t(inputs)
});